<template>
<div class="chapter">
<div class="inner_page">
<h1>2</h1>
<blockquote>
<p class="first">…a juror is a person what usually gets fifteen dollars a day for listening to a lawyer what usually gets fifteen dollars a minute for defending a sex-murderer what usually gets fifteen days probation…</p>
<p style="text-align:right;"><i>Monroe D. Underwood</i></p>
</blockquote>
<p class="sectiontop">Wallace said there’s been some big bastard looking for you.</p>
<p>He said he’s been in and out of here all afternoon.</p>
<p>He said it has something to do with you not showing up for jury duty.</p>
<p>He said I think he mentioned ten times.</p>
<p>I shrugged.</p>
<p>I said Wallace I’m not qualified for jury duty.</p>
<p>I said I don’t understand Spanish.</p>
<p>I said I already got more than I can handle with English.</p>
<p>Spice Dugan took my arm.</p>
<p>She said don’t you think we should talk somewhere else?</p>
<p>Wallace said what should I tell him if he comes in again?</p>
<p>I shrugged.</p>
<p>I said anything but my address.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 07_Ch02.vue?5d9fa0e6